import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { homeRedirectGuard } from './core/auth/home-redirect.guard';
import { projectAdminGuard } from './core/auth/project-admin.guard';
import { roleGuard } from './core/auth/role.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

export const routes: Routes = [
  // Public routes
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'access-request',
    loadComponent: () =>
      import('./features/auth/access-request/access-request.component').then(
        (m) => m.AccessRequestComponent,
      ),
  },
  {
    path: 'access-pending',
    loadComponent: () =>
      import('./features/auth/access-pending/access-pending.component').then(
        (m) => m.AccessPendingComponent,
      ),
  },
  {
    path: 'access-rejected',
    loadComponent: () =>
      import('./features/auth/access-rejected/access-rejected.component').then(
        (m) => m.AccessRejectedComponent,
      ),
  },

  // Share link routes — require login, no MainLayout chrome needed
  {
    path: 'share/leave-tracker/:token',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/shared-leave-tracker/shared-leave-tracker.component').then(
        (m) => m.SharedLeaveTrackerComponent,
      ),
  },

  // Authenticated shell
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      // Home: redirect admins → /accounts, members → /accounts/:id
      {
        path: '',
        pathMatch: 'full',
        canActivate: [homeRedirectGuard],
        loadComponent: () =>
          import('./shared/components/loading-spinner/loading-spinner.component').then(
            (m) => m.LoadingSpinnerComponent,
          ),
      },
      {
        path: 'projects',
        loadChildren: () =>
          import('./features/projects/projects.routes').then((m) => m.projectsRoutes),
      },
      {
        path: 'action-items',
        loadComponent: () =>
          import('./features/action-items/action-items-page.component').then(
            (m) => m.ActionItemsPageComponent,
          ),
      },
      {
        path: 'tickets',
        loadComponent: () =>
          import('./features/tickets/ticket-list.component').then(
            (m) => m.TicketListComponent,
          ),
      },
      {
        path: 'work-log-updates',
        canActivate: [projectAdminGuard],
        loadComponent: () =>
          import('./features/work-log-summary/work-log-summary.component').then(
            (m) => m.WorkLogSummaryComponent,
          ),
      },
      // Accounts list — admin only
      {
        path: 'accounts',
        pathMatch: 'full',
        canActivate: [roleGuard],
        loadComponent: () =>
          import('./features/accounts/account-list/account-list.component').then(
            (m) => m.AccountListComponent,
          ),
      },
      // Account detail (dashboard, libraries) — any authenticated user
      // Backend enforces that non-admins can only see their own account
      {
        path: 'accounts/:id',
        loadComponent: () =>
          import('./features/accounts/account-detail/account-detail.component').then(
            (m) => m.AccountDetailComponent,
          ),
      },
      {
        path: 'admin-settings',
        canActivate: [roleGuard],
        loadComponent: () =>
          import('./features/admin-settings/admin-settings.component').then((m) => m.AdminSettingsComponent),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/my-profile.component').then((m) => m.MyProfileComponent),
      },
      {
        path: 'workspace',
        loadComponent: () =>
          import('./features/workspace/workspace.component').then((m) => m.WorkspaceComponent),
      },
    ],
  },

  { path: '**', redirectTo: '' },
];
